
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Alcoholic from './alcoholic';

const fetchImage = async (id) => {
    const imageBlob = await getImage(id);
    if (imageBlob) {
        return URL.createObjectURL(imageBlob.data.blob);
    }
    return null;
};

const Item = ({ data, categoryMenus, onPress }) => {
    const [image, setImage] = useState(false);
    useEffect(() => {
        fetchImage(`menu-image-h-${data.id}`).then((url) => {
            if (url) setImage(url);
        });
    }, [data.id]);

    return (
        <div onClick={onPress} style={{
            backgroundColor: '#871014',
            width: '100%',
            maxHeight: 450,
            margin: '0px 0px 15px',
            textAlign: 'left',
            paddingBottom: 20,
            boxSizing: 'border-box',
            position: 'relative',
            borderRadius: 15,
        }}>
            <img src={image} style={{width: '100%', height: 200, objectFit: 'cover', borderRadius: 10}} />
            <h3 style={{ color: '#f9e6c8', textTransform: 'uppercase', fontSize: 24, margin: '10px 0 0', textAlign: 'left', fontFamily: 'Noodle', marginLeft: 20 }}>
                {data.name}
            </h3>
            <div style={{width: '100%', margin: '0 auto'}}>
                <p className='shor-text-one' style={{ fontFamily: 'Noodle', fontSize: 18, color: '#f9e6c8', textAlign: 'left', margin: 0, textTransform: 'uppercase', fontWeight: '500', marginLeft: 20 }}>
                    {`${data.regular_decription.replace(/\\n/g, '\n')}`}
                </p>
            </div>
        </div>
    );
};

function Index({dishs, setShowListProduct, goHome, scrollToId}) {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);

     const [showCategories, setshowCategories] = useState(false);
    const [titleCategorie, setIitleCategorie] = useState('');

    const [menusData, setMenusData] = useState([]);
     const [menus, setMenus] = useState(menusCurrent);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [activeCategory, setActiveCategory] = useState(scrollToId || null);
    const scrollContainerRef = useRef(null);
    const tabsContainerRef = useRef(null);

    const EXCLUDED_IDS = [767, 444, 445, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567];

     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);

    
    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);

      useEffect(() => {
        menusData.map((item) => {

            if (item.id === 883) {
                setBeverages(item);
            }
        });
      }, [menusData]);

    useEffect(() => {
        if (scrollToId && menusData.length > 0) {
            setTimeout(() => {
                const section = document.getElementById(`category-section-${scrollToId}`);
                if (section) {
                    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 150);
        }
    }, [menusData]);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container || menusData.length === 0) return;

        let ticking = false;
        const handleScroll = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                const containerTop = container.getBoundingClientRect().top;
                let currentId = null;
                menusData.filter(cat => !EXCLUDED_IDS.includes(cat.id)).forEach(cat => {
                    const section = document.getElementById(`category-section-${cat.id}`);
                    if (section) {
                        const sectionTop = section.getBoundingClientRect().top - containerTop;
                        if (sectionTop <= 80) currentId = cat.id;
                    }
                });
                if (currentId !== null) setActiveCategory(currentId);
                ticking = false;
            });
        };

        container.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return () => container.removeEventListener('scroll', handleScroll);
    }, [menusData]);

    useEffect(() => {
        if (activeCategory && tabsContainerRef.current) {
            const activeTab = tabsContainerRef.current.querySelector(`[data-cat-id="${activeCategory}"]`);
            if (activeTab) {
                activeTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
        }
    }, [activeCategory]);
    
const GoBeverages = () => {
          console.log({Beverages});
         setMenus(Beverages.menus)
    }


    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
               GoBeverages()
        }} showCocktails={ setShowCocktails}  showLamp={ false}   showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials}>
                
                <div ref={tabsContainerRef} style={{
                    background: '#c40722',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '94%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '12px 14px',
                    gap: 12,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 30
                }}>
                    {menusData.map((item, key) => {
                        if (!EXCLUDED_IDS.includes(item.id)) {
                            const isActive = activeCategory === item.id;
                            return <div
                                key={key}
                                data-cat-id={item.id}
                                style={{
                                    background: isActive ? '#871014' : '#f9e6c8',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '12px 28px',
                                    borderRadius: 25,
                                    minWidth: 'fit-content',
                                    transition: 'background 0.3s',
                                    border: isActive ? '2px solid #f9e6c8' : '2px solid transparent',
                                }}
                                onClick={() => {
                                    setActiveCategory(item.id);
                                    const container = scrollContainerRef.current;
                                    const section = document.getElementById(`category-section-${item.id}`);
                                    if (section && container) {
                                        const containerTop = container.getBoundingClientRect().top;
                                        const sectionTop = section.getBoundingClientRect().top - containerTop + container.scrollTop;
                                        container.scrollTo({ top: sectionTop, behavior: 'smooth' });
                                    }
                                }}
                            >
                                <p className='shor-text' style={{ color: isActive ? '#f9e6c8' : '#000', fontFamily: 'Noodle', fontSize: 27, margin: 0, textTransform: 'uppercase', transition: 'color 0.3s' }}>
                                    {item.name}
                                </p>
                            </div>;
                        }
                    })}
                </div>

{/*              
                <div style={{ width: '100%', height: 100,  boxSizing: 'border-box', marginTop: 10, marginBottom: 40 }}>
                    <img src={require('./assets/sidescarnes.png')} style={{width: '100%', height: 134, objectFit: 'contain', borderRadius: 15}} />
                </div> */}
                <div >

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 40,
                        paddingInline: 10
                    }}>
                         <div style={{ width: '40%', marginTop: 105 }}>
                            <img src={require('./assets/BANNERBEBIDAS.png')} style={{width: '100%', height: 570, objectFit: 'cover', borderRadius: 15}} />
                        </div>
                        <div ref={scrollContainerRef} style={{
                            width: '60%',
                            overflowY: 'scroll',
                            maxHeight: 640,
                            marginTop: 15,
                            paddingBottom: 40,
                        }}>
                            {menusData
                                .filter(cat => !EXCLUDED_IDS.includes(cat.id))
                                .map((cat, catKey) => (
                                    <div key={catKey} id={`category-section-${cat.id}`}>
                                        <h2 style={{
                                            color: '#000000',
                                            fontFamily: 'Noodle',
                                            fontSize: 48,
                                            textTransform: 'uppercase',
                                            margin: catKey === 0 ? '0 0 20px' : '60px 0 20px',
                                            paddingBottom: 10,
                                            borderBottom: '2px solid rgba(255,255,255,0.3)',
                                            lineHeight: 1.1,
                                        }}>
                                            {cat.name}
                                        </h2>
                                        <div style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '4%',
                                        }}>
                                            {cat.menus && cat.menus.map((item, key) => (
                                                <Item
                                                    data={item}
                                                    categoryMenus={cat.menus}
                                                    key={key}
                                                    onPress={() => {
                                                        setShowDetailProduct(true);
                                                        setDataDish({ dish: item, alldish: cat.menus, currentDish: dishs });
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                       
                    </div>
                   
                    
      

                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;